import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type Workspace = {
    countryId: Uuid;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    displayName: string;
    id: Uuid;
    status: WorkspaceStatus;
    storageDatabaseId: Uuid;
    timeZoneId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
};

export enum WorkspaceStatus {
    active = "7ac8806f-b328-45d4-8e9e-64ffda2e70fd",
    deleted = "8c59b033-8fb1-4111-8891-41f800160f61",
};

export const workspaceValidator: zod.ZodType<Workspace> = zod.object({
    countryId: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    displayName: zod.string(),
    id: uuidZodValidator,
    status: zod.enum(WorkspaceStatus),
    storageDatabaseId: uuidZodValidator,
    timeZoneId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
});
